export const buildVersion = {
  version: '1.4',
  buildNumber: 34,
  commit: '3218359fe',
};
